import { NgModuleFactory, Type } from '@angular/core';
import { PageNames } from '~/models/pageNames';

export const lazyWidgets: { path: string; loadChildren: () => Promise<NgModuleFactory<any> | Type<any>> }[] = [
  {
    path: 'stockItems',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'categories',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'uom',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'customers',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'pickList',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'siteTransfers',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'site-transfers',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'vendors',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'addresses',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'files',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'documents',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'videos',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'locations',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'locationTypes',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'facility',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'building',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'floor',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'disposeTo',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'purchaseOrders',
    loadChildren: () => import('../modules/stocks/orders/order.module').then(m => m.OrderModule)
  },
  {
    path: 'salesOrders',
    loadChildren: () => import('../modules/stocks/orders/order.module').then(m => m.OrderModule)
  },
  {
    path: 'departments',
    loadChildren: () => import('../modules/assets/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'conditions',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'asset-conditions',
    loadChildren: () => import('../modules/assets/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'appRoles',
    loadChildren: () => import('../modules/stocks/administration/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'users',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'persons',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'reportViewer',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'report-reports',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'forecast',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'report-forecast',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'stock-custom-report',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'stock-custom-forecast',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'stock-standard-forecast',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'standard-forecast',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'reportDesigner',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'scheduleReport',
    loadChildren: () => import('../modules/stocks/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'transferRequests',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'barcodeCatalog',
    loadChildren: () => import('../modules/stocks/labels/label.module').then(m => m.LabelModule)
  },
  {
    path: 'barcode-catalog',
    loadChildren: () => import('../modules/stocks/labels/label.module').then(m => m.LabelModule)
  },
  {
    path: 'barcodeLabel',
    loadChildren: () => import('../modules/stocks/labels/label.module').then(m => m.LabelModule)
  },
  {
    path: 'barcode-label',
    loadChildren: () => import('../modules/stocks/labels/label.module').then(m => m.LabelModule)
  },
  {
    path: 'labels',
    loadChildren: () => import('../modules/stocks/labels/label.module').then(m => m.LabelModule)
  },
  {
    path: 'pre-printed-label',
    loadChildren: () => import('../modules/stocks/labels/label.module').then(m => m.LabelModule)
  },
  {
    path: 'publicQr',
    loadChildren: () => import('../modules/stocks/labels/label.module').then(m => m.LabelModule)
  },
  {
    path: 'public-qr',
    loadChildren: () => import('../modules/stocks/labels/label.module').then(m => m.LabelModule)
  },
  {
    path: 'copy-barcode-label',
    loadChildren: () => import('../modules/stocks/labels/label.module').then(m => m.LabelModule)
  },
  {
    path: 'barcodeGenerators',
    loadChildren: () => import('../modules/stocks/administration/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'barcode-generators',
    loadChildren: () => import('../modules/stocks/administration/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'barcode-label-print',
    loadChildren: () => import('../modules/stocks/administration/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'buildYourApps',
    loadChildren: () => import('../modules/stocks/administration/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'poApprovals',
    loadChildren: () => import('../modules/stocks/administration/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'soApprovals',
    loadChildren: () => import('../modules/stocks/administration/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'receive',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'pack',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'ship',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'kitting',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'breakdown',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'adjust-inventory',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'physical-inventory',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'stock-to-asset',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'disposeToLocations',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'assigned-assets',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'quantity-per-account',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'mobileAppGroups',
    loadChildren: () => import('../modules/stocks/administration/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'customerTypes',
    loadChildren: () => import('../modules/stocks/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'reset-password-popup',
    loadChildren: () => import('../modules/stocks/stock.module').then(m => m.StockModule)
  },
  {
    path: 'statuses',
    loadChildren: () => import('../modules/assets/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'maintenance-type',
    loadChildren: () => import('../modules/assets/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'asset-types',
    loadChildren: () => import('../modules/assets/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'asset-models',
    loadChildren: () => import('../modules/assets/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'asset-models-2',
    loadChildren: () => import('../modules/assets/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'cycle-count',
    loadChildren: () => import('../modules/assets/transactions/assetTransactions.module').then(m => m.AssetTransactionsModule)
  },{
    path: 'assets',
    loadChildren: () => import('../modules/assets/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'asset-inventory',
    loadChildren: () => import('../modules/assets/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'fundingsource',
    loadChildren: () => import('../modules/assets/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'asset-purchaseOrders',
    loadChildren: () => import('../modules/assets/orders/orders.module').then(m => m.OrdersModule)
  },
  {
    path: 'asset-po-approvals',
    loadChildren: () => import('../modules/assets/administration/asset-admin.module').then(m => m.AssetAdminModule)
  },
  {
    path: 'sites',
    loadChildren: () => import('../common/common.module').then(m => m.CommonModule)
  },
  {
    path: 'asset-transfer-transaction',
    loadChildren: () => import('../modules/assets/transactions/assetTransactions.module').then(m => m.AssetTransactionsModule)
  },
  {
    path: 'asset-reservation',
    loadChildren: () => import('../modules/assets/transactions/assetTransactions.module').then(m => m.AssetTransactionsModule)
  },
  {
    path: 'schedule-maintenance',
    loadChildren: () => import('../modules/assets/transactions/assetTransactions.module').then(m => m.AssetTransactionsModule)
  },
  {
    path: PageNames.ScheduleMaintenance,
    loadChildren: () => import('../modules/assets/transactions/assetTransactions.module').then(m => m.AssetTransactionsModule)
  },
  {
    path: 'perform-maintenance',
    loadChildren: () => import('../modules/assets/transactions/assetTransactions.module').then(m => m.AssetTransactionsModule)
  },
  {
    path: PageNames.PerformMaintenance,
    loadChildren: () => import('../modules/assets/transactions/assetTransactions.module').then(m => m.AssetTransactionsModule)
  },
];

export function lazyArrayToObj() {
  const result:{ [key: string]: () => Promise<NgModuleFactory<any> | Type<any>> } = {};
  for (const w of lazyWidgets) {
    result[w.path] = w.loadChildren;
  }
  return result;
}
